import React, { useEffect, useState } from 'react';
import { isEmpty } from "lodash";
import ReturnProd from './ReturnProd';
import { TableRow, TableCell, Button, TableHead, TableBody, IconButton, Box } from '@material-ui/core';
import { TableLayout } from '../containers/Layout';
import { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { ReportProblemRounded, ReportRounded } from '@material-ui/icons';
import { useFetchTransfers } from '../../../../../../../jsx/hooks/getTransfers';
import { fetchTransferDetails } from '../../../../../../../jsx/actions/transferAction';
import { useDispatch } from 'react-redux';

const formatNumbers =  new Intl.NumberFormat('fr-FR',{ maximumFractionDigits: 0 })

const NewSAV = (props) => {
    const dispatch = useDispatch();

    const [inputValue, setInputValue] = useState('');
    const fetchTransfers = useFetchTransfers("vente");
    const [state, setState] = useState({ 
        sale:{},
        return_sale_display:{},
        return_sale: "",
        errors:{
            return_sale: "",

        },
        form: false,
        return_product:{},

     });
     const [trsf, setTrsf] = useState({});

    const [productListFormattedInitialList, setProductListFormattedInitialList] = useState([])  
    const [productListFormatted, setProductListFormatted] = useState([])  

    useEffect(() => {
        //lance la collecte des sales est  ok 
        if (isEmpty(props.SALES)){
            fetchTransfers()
        }
    }, []);

    useEffect(() => {
        const { CLIENTS } = props;
        console.log("CLIENTS =>>",CLIENTS)
        console.log("CLIENTS =>>",props.SALES)
        const options = Object.values(props.SALES).map( 
            sale => ({
                label: `${CLIENTS[sale.client_id] && CLIENTS[sale.client_id].client_firstname} ${CLIENTS[sale.client_id] && CLIENTS[sale.client_id].client_lastname} - ${sale.nature} - ${new Date(sale.creation_date).toLocaleDateString("fr-FR")} - ${sale.id}`, 
                value: sale.id,
                sale,
            })
        )
        setProductListFormattedInitialList(options)
        setProductListFormatted(options)
    }, [props.SALES,props.CLIENTS]);

    useEffect( () => {
        if (state.sale.id != ""){
            const fetchTransferData = async () => {
            try {
                const data = await dispatch(fetchTransferDetails(state.sale.id));
                setTrsf(data);
            } catch (error) {
                console.error('Error fetching transfer details:', error);
            }
        };
        fetchTransferData();
        }
        
    }, [state.sale.id]);

    const handleSelect = (option, name) => {
        let value = option.value
        let displayName = name +'_display'
        setState(prevState => ({...prevState,
            [name]:value,
            [displayName]:option,
            sale: option.sale
        }))
    }

    const createProductList = () => {
        const { PRODUCTS } = props
        console.log("createProductList >>  ",trsf.products)
        return trsf.products.map((saleItem, i) => {
            let prod = PRODUCTS[saleItem.product_id]
            console.log("createProductList >>  prod",prod)

            const ssTt = parseFloat(saleItem.price_ttc) // prix vendu
            let ssTtBase = parseFloat(prod.prix_venteTTC * saleItem.quantity) // prix base

            let discount = Math.round(
                ( 1 - (saleItem.price_ttc) / (prod.prix_venteTTC * saleItem.quantity ) ) * 10000
                ) / 100 // %

            if( ssTt > ssTtBase ){
                ssTtBase = ssTt
            }
            
            console.log("PRODUCT LIST discount", discount);
            return (
                <TableRow>
                    <TableCell >{prod.name} - {prod.marque}</TableCell>
                    <TableCell>{saleItem.quantity}</TableCell>                                    
                    <TableCell>{formatNumbers.format(ssTt)}</TableCell>
                    <TableCell onClick={()=>setState(prevState => ({...prevState,form: true, return_product:prod}))}>
                        <IconButton  color="secondary">
                            <ReportRounded />
                        </IconButton>
                        {/* <Button className="btn btn-info btn-icon"><i className="zmdi zmdi-alert-polygon"></i></Button> */}
                    </TableCell>
                </TableRow>
            )
        })
    }
    const handleInputChange = (event, newInputValue) => {
        console.log("Update handleInputChange")
        setInputValue(newInputValue);
    
        // Filtrer les options en fonction de la valeur d'entrée
        const filteredOptions = productListFormattedInitialList.filter(
          (option) => option.label.toLowerCase().indexOf(newInputValue.toLowerCase()) > -1
        );
    
        // Limiter les options filtrées à 100
        setProductListFormatted(filteredOptions.slice(0, 100));
        setInputValue(newInputValue);
      };

        return (
            <Box>
                <h4>Nouveau SAV</h4>
                <InputSelectMagasin
                    options={productListFormatted.slice(0, 50)}
                    value={state.return_sale_display}
                    inputValue={inputValue}
                    onInputChange={handleInputChange}
                    onChange={(option) => handleSelect(option,"return_sale")}
                    // isOptionDisabled={(option) => option.disabled === true}
                    label="Choisir la vente"
                />    

                {/* <form className="form-horizontal">
                    <div className={"form-group "+ (state.errors.return_sale ? "has-error" : "") }>
                        <label htmlFor="return_sale" className="col-sm-3 control-label">Choisir la vente</label>
                        <div className="col-sm-9">
                        </div>
                    </div>
                </form> */}

                {!isEmpty(state.sale) && !isEmpty(trsf) && 
                    <div>
                        <label>Selectionner le produit</label>
                        <TableLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Produit</TableCell>
                                    <TableCell>Quantité</TableCell>
                                    <TableCell>Total TTC</TableCell>
                                    <TableCell>Retour</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {createProductList()}
                                <TableRow>
                                    <TableCell colSpan={4}></TableCell>
                                </TableRow>
                            </TableBody>
                        </TableLayout>
                    </div>
                }
                {!isEmpty(state.return_product) && state.form &&
                    <ReturnProd 
                        close={()=>setState(prevState => ({...prevState,return_product: {}, form:false}))} 
                        {...props} 
                        {...state} 
                    />
                }
            </Box>
        );
}

export default NewSAV;